import { ErrorType } from 'gql/__generated__/graphql'

import type { IGraphqlCommonError, IGraphqlError, IGraphqlInputError } from './types'

export const isInputError = (error: IGraphqlError | null): error is IGraphqlInputError =>
  error?.type === ErrorType.InputError

export const isCommonError = (error: IGraphqlError | null): error is IGraphqlCommonError =>
  error?.type === ErrorType.CommonError
